import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Button, MenuList, MenuItem } from '@material-ui/core';
import _ from 'lodash';

import { Dispatch, RootState } from '../../../../configs/store';
import Icon from '../../../Icon/Icon';
import DropDown from '../../../DropDown/DropDown';
import { formatAmountToFixed } from 'src/utils/utils';

function WalletMenuItem() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation('common');

  // REDUX
  const dispatch = useDispatch<Dispatch>();

  const { settings: { showBalance } } = useSelector((state: RootState) => state.content);
  const { customer: { wallets }, localWalletSelected } = useSelector((state: RootState) => state.auth);

  const balance = !_.isEmpty(localWalletSelected) ?
    ((localWalletSelected['creditBalance'] - localWalletSelected['debitBalance']) / localWalletSelected['divisor']).toFixed(2) : 0;

  //#region FUNCTIONS
  const openMenu = () => {
    setOpen(true);
  };

  const closeMenu = () => {
    if (open) {
      setOpen(false);
    }
  };

  const updateWalletVisibility = (value: boolean) => () => {
    setOpen(false);
    dispatch.content.updateSettings({ showBalance: value });
    if (value === true) {
      dispatch.auth.getCustomer();
    }
  };

  const handleOnWalletChange = (wallet) => {
    dispatch.auth.selectLocalWallet(wallet);
    closeMenu();
  };
  //#endregion

  return (
    <>
      <Icon icon="reload" className="top-menu__btn--reload" onClick={ dispatch.auth.getCustomer } />
      <div className="top-menu__item top-menu__item--balance">
        {
          showBalance ?
            <>
              <DropDown
                value={
                  <span className="top-menu__dropdown top-menu__dropdown__top--value" title={ t('topmenu.settings') }>
                    <span className="top-menu__dropdown top-menu__dropdown__top--label">
                      { localWalletSelected && localWalletSelected['type'] ? localWalletSelected['type']['name'] : null }
                    </span>
                    &nbsp;
                    { `${ (!_.isEmpty(localWalletSelected) ? localWalletSelected['currency'] : '') + ' ' + balance }` }
                  </span>
                }
                className="top-menu__dropdown top-menu__dropdown__top"
                IconComponent={ <Icon icon="arrow" /> }
                iconMargin={ true }
                openMenu={ openMenu }
                closeMenu={ closeMenu }
                open={ open }
                placement="bottom-end"
                popperClass="top-menu__wallet"
              >
                <MenuList
                  className="top-menu__sub-menu"
                  autoFocusItem={ open }
                >
                  {
                    _.map(wallets, wallet => (
                      <MenuItem
                        className="top-menu__sub-menu__item"
                        onClick={ () => handleOnWalletChange(wallet) }
                      >
                        <span className="top-menu__sub-menu__item-type">{ wallet?.type?.name }</span>
                        <span className="top-menu__sub-menu__item-currency">{ localWalletSelected && localWalletSelected['currency'] }</span>
                        <span className="top-menu__sub-menu__item-amount">{ formatAmountToFixed(wallet.balance) }</span>
                      </MenuItem>
                    ))
                  }
                  <button
                    onClick={ updateWalletVisibility(false) }
                    className="top-menu__sub-menu__btn"
                  >
                    { t('topmenu.hideBalance') }
                  </button>
                </MenuList>
              </DropDown>
            </>
            :
            <Button
              className="top-menu__btn top-menu__btn--hidden"
              onClick={ updateWalletVisibility(true) }
            >
              { t('topmenu.showBalance') }
            </Button>
        }
      </div>
    </>
  );
}

export default WalletMenuItem;
